const getVideoClass = (count) => {
  if (count < 2) return "local-one";
  if (count < 3) return "local-two";
  if (count === 3) return "local-video-three";
  if (count === 4) return "local-video-four";
  if (count < 7) return "local-video-morethan-four";
  return "local-video-morethan-six";
};

const addScreenShareToParticipants = (participants, screenShareStream, sharerName) => {
  // Step 1: Filter out any existing screen-share participant
  const filtered = participants.filter(p => p.userId !== 'screen-share');

  // Step 2: Add screen share if available
  if (screenShareStream) {
    return [
      ...filtered,
      {
        userId: 'screen-share',
        displayName: sharerName || 'Screen Share',
        stream: screenShareStream,
        isScreenShare: true,
      }
    ];
  }

  return filtered;
};

const getActiveScreenShareStream = (callObj, userId, displayNameUi) => {
  let screenShareStream = null;
  let screenShareParticipant = null;

  // Check remote participants (others sharing)
  callObj.remoteParticipants.forEach((participant) => {
    participant.videoStreams.forEach((stream) => {
      if (stream.mediaStreamType === 'ScreenSharing' && stream.isAvailable) {
        screenShareStream = stream;
        screenShareParticipant = participant;
      }
    });
  });

  // If not found, check local streams (self sharing)
  if (!screenShareStream && callObj.localVideoStreams) {
    callObj.localVideoStreams.forEach((stream) => {
      if (stream.mediaStreamType === 'ScreenSharing') {
        screenShareStream = stream;
        screenShareParticipant = {
          displayName: displayNameUi,
          identifier: { communicationUserId: userId }
        };
      }
    });
  }

  return { screenShareStream, screenShareParticipant };
}

const getClassName = (participantCountGlobal, isRightPanelOpen) => {
  return participantCountGlobal < 3 && !isRightPanelOpen
    ? ".local-video-container-custom"
    : participantCountGlobal < 3 && isRightPanelOpen
      ? ".local-video-container-withmenu-custom"
      : participantCountGlobal === 3
        ? ".local-video-three-custom"
        : participantCountGlobal === 4
          ? ".local-video-four-custom"
          : participantCountGlobal < 7
            ? ".local-video-morethan-four-custom"
            : ".local-video-morethan-six-custom";
};



export { getVideoClass, addScreenShareToParticipants, getActiveScreenShareStream, getClassName };